// extracted by mini-css-extract-plugin
module.exports = {"answer":"Qs","bestAnswerHeading":"Rs","meta":"Ss"};